module.exports = "/assets/e2b4721bc926b009bfb4d721aea93b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DN.png
// module id = 1307
// module chunks = 0